import React from 'react';
import { SwiperOptions } from 'swiper';
import { IProps } from 'components/Slider/types';
import swiperService from 'plugins/swiperService';
import Item from 'components/Slider/Item';

class Slider extends React.Component<IProps, {}> {
  static Item = Item as typeof Item;
  private sliderInstance: any;

  static defaultProps = {
    navigation: true,
    pagination: true
  };

  componentDidMount () {
    this.setUpSlider();
  }

  componentWillUnmount () {
    this.destroySlider();
  }

  // 設置 Slider
  setUpSlider = () => {
    const { name, config } = this.props;
    const container = `.${name}`;
    const options: SwiperOptions = {
      speed: 750,
      navigation: {
        nextEl: `#${name}-next-btn`,
        prevEl: `#${name}-prev-btn`
      },
      pagination: {
        el: `#${name}-pagination`,
        clickable: true,
        bulletClass: 'slider__pagination-bullet',
        bulletActiveClass: 'slider__pagination-bullet--active',
        renderBullet: (index: number, className: string) => {
          return (
            '<li class="' + className + '">' +
              '<div class="slider__pagination-bullet-decoration" />' +
            '</li>'
          );
        }
      },
      ...config
    };
    this.sliderInstance = swiperService.instance(container, options);
  };

  // 銷毀 Slider
  destroySlider = () => {
    this.sliderInstance.destroy(true, true);
  }

  render () {
    const { children, name, navigation, pagination } = this.props;
    return (
      <div className="slider">
        <div className="slider__container">
          <div className={`swiper-container ${name}`}>
            <div className="swiper-wrapper">
              {children}
            </div>
          </div>
          {navigation && (
            <>
              <button type="button" id={`${name}-prev-btn`} className="slider__prev-btn" />
              <button type="button" id={`${name}-next-btn`} className="slider__next-btn" />
            </>
          )}
        </div>
        {pagination && (
          <ul id={`${name}-pagination`} className="slider__pagination" />
        )}
      </div>
    );
  }
};

export default Slider;
